import { apiClient } from './apiClient';
import { format } from 'date-fns';

export interface AbsenceEntryDto {
  id: number;
  externalLeaveId: string;
  source: string;
  absenceType: string | null;
  reason: string | null;
  status: string | null;
  startDate: string | null;
  endDate: string | null;
  duration: string | null;
  durationType: string | null;
  partOfDay: string | null;
  startDatePartOfTheDay: string | null;
  endDatePartOfTheDay: string | null;
  startTime: string | null;
  endTime: string | null;
  comment: string | null;
  hoursPerDay: Record<string, number>;
  defaultProjectId: string | null;
  defaultCostCentreId: string | null;
}

export const absencesApi = {
  /**
   * Fetches absence entries for an employee and week,
   * with per-day hours already computed by the backend.
   */
  async fetchAbsencesForWeek(
    employeeId: number,
    weekEnding: Date,
    companyId?: string,
  ): Promise<AbsenceEntryDto[]> {
    const formattedDate = format(weekEnding, 'yyyy-MM-dd');
    const url = companyId
      ? `/absences/${employeeId}/${formattedDate}?companyId=${companyId}`
      : `/absences/${employeeId}/${formattedDate}`;
    return apiClient.get<AbsenceEntryDto[]>(url);
  },
};
